import { render, staticRenderFns } from "./Home_events.vue?vue&type=template&id=50a31223"
import script from "./Home_events.vue?vue&type=script&lang=js"
export * from "./Home_events.vue?vue&type=script&lang=js"
import style0 from "./Home_events.vue?vue&type=style&index=0&id=50a31223&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports